import { defineStore } from "pinia";
import {
  ClientSession,
  CommandExecutionType,
  CommandParam,
  DataboxAPIConfig,
  UserCredential,
  dataBoxCall,
} from "nmt_databox";
import { customNotify } from "@/utils/Customtoast";

export const useApplicationStore = defineStore("ApplicationStore", {
  //state
  state: () => ({
    $USER: new UserCredential(),
    $APP_READY: false,
    $SESSION: new ClientSession(),
    $DATABOX_CFG: new DataboxAPIConfig("", "", ""),
    environmentConfig: {},

    $BACKGROUND_IMAGE: '',
    $LOGO_IMAGE:'',

    //used by niemitform
    SharedData: {} as any,
  }),

  //action
  actions: {
    async makeRequest(
      params: CommandParam[],
      procedura: string,
      excommand = CommandExecutionType.ExecuteQuery,
      errorMsg?: string
    ) {
      const resonseData: any = await dataBoxCall.Exec(
        params,
        `${procedura}`,
        true,
        errorMsg ?? "Errore durante l'esecuzione della procedura!",
        excommand,
        false,
        this.$DATABOX_CFG
      );

      return resonseData;
    },

    isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },

    ShowErrorMessge(prm: CommandParam[]) {
      // stpV_zSys_Messages_get_v001
      // @Msg_codi NCHAR(7), -->put here errMsg OUTPUT param
      // @Msg_desc nvarchar(800) OUTPUT, --output parameter

      dataBoxCall
        .Exec(
          prm,
          // this.ErrorMessageProcedure,
          "stpV_zSys_Messages_get_v001",
          true,
          "Errore durante l'esecuzione della procedura!",
          CommandExecutionType.ExecuteNonQuery,
          false,
          this.$DATABOX_CFG
        )
        .then((data: any) => {
          customNotify(data.OutputParams.Table[0]["Msg_desc"], "error");
        });
    },
  },
});
